<template>
    <div class="wrap">
        <div class="container container_top">
            <div class="carts">
                <van-checkbox-group v-model="goods_checkbox" ref="checkboxGroup">
                    <div class="carts_goods" v-for="(value,index) in cart_list" :key="index">
                        <van-row class="goods_check" type="flex" align="center" justify="space-between">
                            <van-checkbox icon-size="20px" checked-color="#FE7A72" :name="value.id" :disabled="(value.is_error == 1) ? true : false"  @click="checkBoxClick"></van-checkbox>
                            <van-icon color="#FE7A72" size="20" name="delete" @click="del(value.id,index)" />
                        </van-row>
                        <van-card :title="value.title" :thumb-link="'/#/details?id='+value.goods_id">
                            <template #thumb>
                                <van-image width="88" height="88" lazy-load :src="value.images" />
                            </template>
                            <template #tags>
                                <van-row type="flex" align="center" class="carts_bh">
                                    <font>商品ID:</font>
                                    <van-tag round color="#eee" text-color="#333" type="primary">{{value.goods_id}}
                                    </van-tag>
                                </van-row>
                                <van-row class="goods_specs">
                                    <van-col span="24" v-for="(value1,index1) in value.spec" :key="index1">{{value1.type}}:{{value1.value}}</van-col>
                                </van-row>
                            </template>
                            <template #price>
                                <div class="carts_price">
                                    商品价格: <s>￥{{Number(value.original_price*value.stock).toFixed(2)}}</s><span>￥<font>{{Number(value.price*value.stock).toFixed(2)}}</font></span>
                                </div>
                            </template>
                            <template #footer>
                                <van-row type="flex" align="center" class="goods_sj">
                                    <font>数量:</font>
                                    <van-stepper @change="stock($event,value.id,value.goods_id,index)" input-width="30px" button-size="22px" :default-value="value.stock" />
                                </van-row>
                            </template>
                        </van-card>
                    </div>
                </van-checkbox-group>
                <van-empty description="暂无商品..." v-if="cart_list.length <= 0"></van-empty>
            </div>
            <div class="carts_but">
                <!-- <div class="cart_tips">Get more sale with<font>Coupons</font> in the next step!</div>
                <div class="cat_price">Total:<font>￥599.48</font>
                </div> -->
                <van-row type="flex" align="center" justify="center">
                    <van-col class="cart_qx" span="12" @click="toggleAll">
                            <van-checkbox v-model="select_all" name="1" icon-size="20px" checked-color="#FE7A72" :disabled="cart_list.length <= 0">全选</van-checkbox>
                    </van-col>
                    <van-col span="12">
                        <div  @click="to_pay">
                            <van-button block type="primary">继续付款</van-button>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .wrap {
        background: #f3f3f3;
        min-height: 100vh;
    }
    #cart_box{
        display: none;
    }
    .fixed-carts{
        display: none;
    }
.container_top{margin-top:45px}
</style>
<script>
    export default {
        components: {},
        created() {
            this.getData();
        },
        data() {
            return {
                goods_checkbox: [],
                goods_number: '1',
                quanxuan: [],
                cart_list: [],
                select_all: true
            }
        },
        methods: {
            checkBoxClick(){
                window.console.log(this.goods_checkbox)
                this.select_all = this.goods_checkbox.length === this.cart_list.length && this.cart_list.length !== 0;
            },
            toggleAll() {
                if(this.select_all){
                    this.$refs.checkboxGroup.toggleAll(false);
                }else {
                    this.$refs.checkboxGroup.toggleAll(true);
                }
            },
            getData(){
                var url = 'api/cart/index';
                var _self = this;
                this.GET(url,function (data) {
                    _self.cart_list = data.data.data;
                    for (var i = 0; i <  _self.cart_list.length; i++){
                        _self.goods_checkbox.push(_self.cart_list[i].id)
                    }
                })
            },
            stock(stock,id,goods_id,index){
                var data = {stock:stock,id:id,goods_id:goods_id}
                var url = 'api/cart/stock';
                var _self = this;
                this.POST(url,data,function (data) {
                    if(data.code == 0){
                        _self.cart_list[index].stock = stock;
                    }
                    _self.$toast(data.msg)
                })
            },
            to_pay(){
                //暂时不用跳登录页面 2020年9月15日10:12:56
                // var user_info = this.getUserInfo(true);
                // if(user_info === false){
                //     return false;
                // }
                if(this.goods_checkbox.length > 0){
                    this.$router.push({path:'/pay',query:{ids:this.goods_checkbox.join(","),buy_type:'cart'}})
                }else{
                    this.$toast('请选择商品')
                }
            },
            del(id,index){
                var url = "api/cart/delete";
                var data = {id:id}
                var _self = this;

                this.$dialog.confirm({
                    title: '提示',
                    message: '删除后无法还原，您确定要继续吗？',
                }).then(() => {
                        this.POST(url,data,function (data) {
                            if(data.code == 0){
                                _self.cart_list.splice(index,1);
                                var cart_count = document.getElementById("cart_total").innerText;
                                document.getElementById("cart_total").innerText = Number(cart_count) - 1;
                            }
                        })
                    }).catch(() => {
                        // on cancel
                    });
                return false;

            }
        },
    }
</script>